// extracted by mini-css-extract-plugin
export default {"container":"ViewMore_container__NG+uz"};